import React, { useState, useRef, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

const MilestoneModal = ({ isOpen, onClose, onSubmit, currentRating }) => {
  const [milestoneRecord, setMilestoneRecord] = useState("");
  const [status, setStatus] = useState("Upcoming");
  const [network, setNetwork] = useState("google");
  const [isMilestoneDropdownOpen, setIsMilestoneDropdownOpen] = useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isNetworkDropdownOpen, setIsNetworkDropdownOpen] = useState(false);

  const milestoneRef = useRef(null);
  const statusRef = useRef(null);
  const networkRef = useRef(null);

  const milestoneOptions = [];
  for (let i = 1; i <= 10; i++) {
    if (currentRating + 0.1 * i <= 5) {
      milestoneOptions.push((currentRating + 0.1 * i).toFixed(1));
    }
  }

  const statusOptions = ["Start", "Achieved", "Current", "Upcoming"];
  const networkOptions = [
    "google",
    "booking",
    "tripadvisor",
    "expedia",
    "agoda",
    "yelp",
  ];

  // Helper function to capitalize first letter
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        milestoneRef.current &&
        !milestoneRef.current.contains(event.target)
      ) {
        setIsMilestoneDropdownOpen(false);
      }
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setIsStatusDropdownOpen(false);
      }
      if (networkRef.current && !networkRef.current.contains(event.target)) {
        setIsNetworkDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (milestoneRecord && status && network) {
      onSubmit({
        milestoneRecord: parseFloat(milestoneRecord),
        status,
        network,
      });
      // Reset form
      setMilestoneRecord("");
      setStatus("Upcoming");
      setNetwork("google");
      onClose();
    }
  };

  const handleClose = () => {
    setMilestoneRecord("");
    setStatus("Upcoming");
    setNetwork("google");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] flex flex-col  ">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-lg font-semibold">New Milestone</h2>
          <button
            onClick={handleClose}
            className="text-gray-600 hover:text-gray-900 p-1"
            aria-label="Close modal"
          >
            <AiOutlineClose size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6 overflow-y-auto">
          {/* Milestone Record */}
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Milestone
            </label>
            <div className="relative" ref={milestoneRef}>
              <button
                type="button"
                disabled={currentRating >= 5}
                onClick={() => {
                  setIsMilestoneDropdownOpen(!isMilestoneDropdownOpen);
                  setIsStatusDropdownOpen(false);
                  setIsNetworkDropdownOpen(false);
                }}
                className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <span
                  className={
                    milestoneRecord ? "text-gray-900" : "text-gray-400"
                  }
                >
                  {currentRating >= 5 ? "Maximum rating (5.0) achieved!" : (milestoneRecord || "Select milestone")}
                </span>
                {currentRating < 5 && (
                  <svg
                    className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                      isMilestoneDropdownOpen ? "rotate-180" : ""
                    }`}
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
              {isMilestoneDropdownOpen && currentRating < 5 && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-[80px] overflow-y-auto">
                  {milestoneOptions.map((option) => (
                    <button
                      key={option}
                      type="button"
                      onClick={() => {
                        setMilestoneRecord(option);
                        setIsMilestoneDropdownOpen(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
                    >
                      {option}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* Network */}
          {/* <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Network
            </label>
            <div className="relative" ref={networkRef}>
              <button
                type="button"
                onClick={() => {
                  setIsNetworkDropdownOpen(!isNetworkDropdownOpen);
                  setIsMilestoneDropdownOpen(false);
                  setIsStatusDropdownOpen(false);
                }}
                className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
              >
                <span className={network ? "text-gray-900" : "text-gray-400"}>
                  {network ? capitalizeFirstLetter(network) : "Select network"}
                </span>
                <svg
                  className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                    isNetworkDropdownOpen ? "rotate-180" : ""
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              {isNetworkDropdownOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                  {networkOptions.map((option) => (
                    <button
                      key={option}
                      type="button"
                      onClick={() => {
                        setNetwork(option); // Store lowercase
                        setIsNetworkDropdownOpen(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
                    >
                      {capitalizeFirstLetter(option)}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div> */}
          {/* Submit Button */}
          <div className="flex justify-end pt-4 border-t">
            <button
              type="submit"
              disabled={currentRating >= 5 || !milestoneRecord}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MilestoneModal;
